export default "__VITE_ASSET__50ab3126__"